/* eslint-disable @typescript-eslint/no-explicit-any */
import { RemoteStatus } from '../Remote';
var isLoadingRemote = function (remote) {
    if (Array.isArray(remote))
        return remote.some(function (_a) {
            var status = _a.status;
            return status === RemoteStatus.Loading;
        });
    return remote.status === RemoteStatus.Loading;
};
export default isLoadingRemote;
//# sourceMappingURL=isLoadingRemote.js.map